import OrderOptimizerPotentialDriversList, {
  OrderOptimizerPotentialDriversListItem,
} from "../../../../../../../common/services/order-optimizer/potential-drivers-list/order-optimizer-potential-drivers-list";
import { OrderOptimizerRailyDetailsHiddenDetailsDriverListItem } from "../types/order-optimizer-raily-details-hidden-details-driver-list";

const createPotentialDriverListItem = (
  item: OrderOptimizerPotentialDriversListItem
): OrderOptimizerRailyDetailsHiddenDetailsDriverListItem => {
  return {
    driver: item.driver,
    taxiDriverAssociationUuid: item.taxiDriverAssociationUuid,
    saDistance: item.saDistance,
    taxiCorporation: item.taxiCorporation,
  };
};

const createPotentialDriverList = (
  response: OrderOptimizerPotentialDriversList
): OrderOptimizerRailyDetailsHiddenDetailsDriverListItem[] => {
  return response.map(createPotentialDriverListItem);
};

const orderOptimizerRailyDetailsHiddenDetailsDriverListFactory = {
  createPotentialDriverList,
};

export default orderOptimizerRailyDetailsHiddenDetailsDriverListFactory;
